import React from 'react';
import "../styles/Home.css";
import { Fade } from '@mui/material';
import { Email, ExpandMore, LocationOn, PhoneIphone } from '@mui/icons-material';
import Domains from './Domains';

const Main = () => {
  return (
    <main className="main">
      <section>
        <div className="sectionHome">
          <div className="sectionTitle">
            <h1 style={{fontSize: "2rem", color: "#493f7e", textAlign: "center"}}>
              Isabelle PIVET<br/>
              Avocat au barreau de Vienne
            </h1>
          </div>
          <article className="presentation">

            <div className="rightPresentation">
              {/* <img
                src={carte}
                alt='Maître Isabelle PIVET'
                className="imgHome"
              /> */}
              <div className='titleHome' style={{color: "#493f7e", marginTop: 0}}>
              <img
                src="/images/logo-isabelle-pivet.png"
                alt='Carte Isabelle Pivet'
                width={150}
                height={150}
                className="imgPivet"
                // style={{
                //   marginTop: 20
                // }}
            />
              </div>

              <div className='textPresentation'>
                <p>
                  Avocat au Barreau de Vienne (Isère), Maître Isabelle PIVET exerce une activité en droit dans plusieurs domaines.
                </p>
                <p style={{textIndent: 20}}>
                  Elle intervient sur toutes les problématiques afférentes à la vie des affaires (Droit des sociétés, droit commercial, droit social)
                  et accompagne les entreprises de toutes tailles ainsi que les particuliers tant en conseil qu’en contentieux.
                </p>
                <p style={{textIndent: 20}}>
                  Maître Isabelle PIVET vous assiste également en droit de la famille (Divorce, séparation, garde des enfants, assistance éducative),
                  ainsi qu’en droit pénal (assistance et représentation des victimes ou des mises en cause devant les juridictions pénales).
                  Elle vous conseillera en droit pénal, que vous soyez auteur ou victime, en droit des mineurs. Maître Isabelle PIVET vous accompagnera dans toutes les étapes de la procédure.
                </p>
              </div>
            {/* <img src={vienne} alt='Maître Isabelle PIVET' className="imgHome" /> */}
            </div>
            <div className="leftPresentation">
              <LocationOn fontSize="large" color="action" />
              <p>2 Rue du Musée 38200 VIENNE</p>
              <PhoneIphone fontSize="large" color="action" />
              <p>Téléphone : 06 15 40 05 60</p>
              <Email fontSize="large" color="action" />
              <p>Adresse E-mail : maitreisabellepivet@gmail.com</p>
              <a href="/contact">
                <div className="btnMail">
                  <p>Envoyer un mail à Maître Isabelle PIVET</p>
                </div>

              </a>
            </div>
          </article>
          <div style={{margin: "20px 0"}}>
            <Fade in {... {timeout: 2000}}>
              <ExpandMore fontSize="large" />
            </Fade>

          </div>
          <div className="sectionParallax">
            <div className="titles">
              <h1 className="titleHome">
                Isabelle PIVET
              </h1>
              <h2 className="titleSmallHome">
                Avocat au Barreau de Vienne
              </h2>
            </div>

          </div>
          <div style={{margin: "20px 0"}}>
            <Fade in {... {timeout: 2000}}>
              <ExpandMore fontSize="large" />
            </Fade>

          </div>
        </div>
        <Domains />
      </section>
    </main>
  )
}
export default Main;
